import { render, staticRenderFns } from "./Ratio.vue?vue&type=template&id=656d0f8c&"
import script from "./Ratio.vue?vue&type=script&lang=js&"
export * from "./Ratio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports